import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';

import qs from 'qs';

import {
  LOCATION_BASE,
  LOCATION_OFFLINE
} from 'bento-ordering/locations/constants/paths';
import { CART_ITEMS_EXPIRED } from 'bento-ordering/cart/constants/notificationTypes';
import { closeModal } from 'bento-ordering/base/actions/modal';
import { isMobileMedia } from 'bento-ordering/utils/media';
import { MENU } from 'bento-ordering/menus/constants/entities';

import MenuSectionsContainer from 'bento-ordering/menus/containers/MenuSectionsContainer';
import MenuModalManager from 'bento-ordering/menus/containers/MenuModalManager';
import ErrorBoundary from 'bento-ordering/base/components/ErrorBoundary';

import NotificationModalContainer from 'bento-ordering/base/containers/NotificationModalContainer';
import { resetError } from 'bento-ordering/cart/actions';
import { openNotificationModal } from 'bento-ordering/base/actions/notificationModals';
import PageLoadSpinner from 'components/PageLoadSpinner';
import SeoTitleUpdater from 'components/SeoTitleUpdater';

import { isSoleEntity } from 'bento-ordering/base/reducers/bentoApi';

import {
  isLocationClosedSelector,
  selectOnlineOrderingLocationName
} from 'bento-ordering/locations/selectors';
import SuccessfulAddSnackbarV2 from 'bento-ordering/base/components/Snackbar/SuccessfulAddSnackbarV2';
import { selectIsUpsellItemAddedFromCart } from 'bento-ordering/cart/utils/menuUpsellSelectors';
class MenuContainer extends React.PureComponent {
  static propTypes = {
    shouldOpenOrderSettingModal: PropTypes.bool,
    shouldOpenMenuItemDetailModal: PropTypes.bool,
    shouldOpenEditCartItemModal: PropTypes.bool,
    dispatch: PropTypes.func,
    selectedLocationIsClosed: PropTypes.bool,
    location: PropTypes.object,
    lastItem: PropTypes.shape({
      product: PropTypes.number,
      name: PropTypes.string
    }).isRequired,
    menuIsFetching: PropTypes.bool,
    isSingleLocation: PropTypes.bool,
    shouldOpenCart: PropTypes.bool,
    scrollManager: PropTypes.object,
    isError: PropTypes.bool,
    googleLoaded: PropTypes.bool.isRequired,
    menuId: PropTypes.number,
    isUpsellItem: PropTypes.bool.isRequired,
    shouldOpenModal: PropTypes.bool,
    locationName: PropTypes.string.isRequired
  };

  static defaultProps = {
    menuId: null
  };

  componentDidMount() {
    this.determineScrollPosition();
    this.handleExpiredItems();
    this.focusFullfillmentMethod();
  }

  /**
   * Focus fullfilment method when gos to Menu container after
   * close a modal realated to the fullfilment method.
   */
  focusFullfillmentMethod = () => {
    const selectedFulfillmentMethod = sessionStorage.getItem(
      'selectedFulfillmentMethod'
    );
    if (isMobileMedia && selectedFulfillmentMethod) {
      const element = document.getElementById(
        `${selectedFulfillmentMethod}-option`
      );

      // Only focus on the button if Fulfillment method option is present.
      if (element) {
        const button = element.querySelector('button');
        button.focus();
      }

      sessionStorage.removeItem('action');
    }
  };

  /**
   * Only call scroll if a position > 0 exist. The scroll position of
   * the Menu is set in the menu item detail click handler. The menu scroll
   * position gets reset to 0 on all other components.
   */
  determineScrollPosition = () => {
    const { scrollManager } = this.props;
    if (isMobileMedia() && scrollManager[MENU] > 0) {
      window.scroll(0, scrollManager[MENU]);
    }
  };

  resetError = () => {
    this.props.dispatch(resetError());
  };

  handleExpiredItems = () => {
    const { location, dispatch } = this.props;
    const params = qs.parse(location.search.replace('?', ''));
    const expired = params.expired;
    if (expired) {
      dispatch(openNotificationModal(CART_ITEMS_EXPIRED));
    }
  };

  render() {
    const {
      shouldOpenOrderSettingModal,
      shouldOpenMenuItemDetailModal,
      shouldOpenEditCartItemModal,
      dispatch,
      menuId,
      lastItem,
      menuIsFetching,
      selectedLocationIsClosed,
      isSingleLocation,
      shouldOpenCart,
      isError,
      googleLoaded,
      isUpsellItem,
      shouldOpenModal
    } = this.props;
    /**
     * Redirect to offline page if it's single location
     * and there are errors loading the menu
     */
    if (isError && isSingleLocation) {
      return <Redirect to={LOCATION_OFFLINE} />;
    }

    /**
     * redirect the user to locations list page if the specified
     * location is offline
     *
     * Return to the locations list page if there are errors and
     * it is multi location
     */
    if (selectedLocationIsClosed || (isError && !isSingleLocation)) {
      dispatch(closeModal());
      return <Redirect to={LOCATION_BASE} />;
    }

    if (menuIsFetching || !googleLoaded) {
      return <PageLoadSpinner />;
    }

    return (
      <ErrorBoundary>
        <React.Fragment>
          <SeoTitleUpdater
            section={isSingleLocation ? null : 'Locations'}
            locationName={`${this.props.locationName} Menu`}
          />
          <div style={{ marginBottom: '10px' }} />

          {menuId && <MenuSectionsContainer />}
          <MenuModalManager
            shouldOpenMenuItemDetailModal={shouldOpenMenuItemDetailModal}
            shouldOpenOrderSettingModal={shouldOpenOrderSettingModal}
            shouldOpenEditCartItemModal={shouldOpenEditCartItemModal}
            shouldOpenCart={shouldOpenCart}
            shouldOpenModal={shouldOpenModal}
          />
          {!!lastItem.name && !isUpsellItem && (
            <SuccessfulAddSnackbarV2 item={lastItem.name} />
          )}
          <NotificationModalContainer />
        </React.Fragment>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = ({
  cart,
  restaurantLocations,
  lastItem,
  menu,
  scrollManager,
  libraryLoad,
  router
}) => {
  const isClosed = isLocationClosedSelector(
    restaurantLocations,
    cart.online_ordering_location
  );

  const isUpsellItem = selectIsUpsellItemAddedFromCart(lastItem, menu, router);
  const locationName = selectOnlineOrderingLocationName(
    restaurantLocations,
    cart.online_ordering_location
  );

  return {
    isSingleLocation: isSoleEntity(restaurantLocations),
    selectedLocationIsClosed: isClosed,
    menuIsFetching: menu.isFetching,
    lastItem: lastItem.add,
    menuId: menu.id,
    scrollManager,
    isError: menu.isError,
    googleLoaded: libraryLoad.google,
    isUpsellItem,
    locationName
  };
};
export default withRouter(connect(mapStateToProps)(MenuContainer));
